export const EMBRYO_CATEGORY_COLORS = {
  day5: 'bg-purple-200 border-purple-400',
  exportNonEU: 'bg-red-50 border-red-300',
  export: 'bg-amber-50 border-amber-200',
  freezeOnly: 'bg-blue-50 border-blue-200',
  ship: 'bg-gray-50 border-gray-200',
  halfPlateDiffSires: 'bg-red-50 border-red-300',
} as const;

export const EMBRYO_CATEGORY_COLOR_KEY_ITEMS = [
  {
    key: 'day5',
    colorClass: EMBRYO_CATEGORY_COLORS.day5,
    translationKey: 'fertWork.day5',
  },
  {
    key: 'exportNonEU',
    colorClass: EMBRYO_CATEGORY_COLORS.exportNonEU,
    translationKey: 'fertWork.exportNonEU',
  },
  {
    key: 'export',
    colorClass: EMBRYO_CATEGORY_COLORS.export,
    translationKey: 'fertWork.export',
  },
  {
    key: 'freezeOnly',
    colorClass: EMBRYO_CATEGORY_COLORS.freezeOnly,
    translationKey: 'fertWork.freezeOnly',
  },
  {
    key: 'ship',
    colorClass: EMBRYO_CATEGORY_COLORS.ship,
    translationKey: 'fertWork.ship',
  },
  {
    key: 'halfPlateDiffSires',
    colorClass: EMBRYO_CATEGORY_COLORS.halfPlateDiffSires,
    translationKey: 'fertWork.halfPlateDiffSires',
  },
] as const;

export const getEmbryoCategoryColorClass = (opts: {
  isDay5?: boolean;
  planCategory?: string | null;
}): string => {
  if (opts.isDay5) return EMBRYO_CATEGORY_COLORS.day5;
  const plan = opts.planCategory || '';
  if (plan === 'ExportNonEU') return EMBRYO_CATEGORY_COLORS.exportNonEU;
  if (plan.startsWith('Export')) return EMBRYO_CATEGORY_COLORS.export;
  if (plan === 'FreezeOnly') return EMBRYO_CATEGORY_COLORS.freezeOnly;
  return EMBRYO_CATEGORY_COLORS.ship;
};
